import React, { useContext } from "react";
import { Navigate } from "react-router-dom";

import { AppRulesContext } from "../App";
import { IPermissionConfig } from "../config/interfaces";

interface Props {
  rules?: IPermissionConfig;
  element: JSX.Element;
}

const GuardedRoute: React.FC<Props> = ({ rules, element }: Props) => {
  const { rulesSvc } = useContext(AppRulesContext);

  if (rules) {
    const canAccess = rulesSvc.canAccess(rules);
    if (canAccess) {
      return element;
    }
    return <Navigate to="/" />;
  }

  return element;
};

export default GuardedRoute;
